export default __webpack_public_path__ + "static/media/HRP2.75faccde.jpg";